import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const getDocAnchorId = (method, path) => `anchor-${method}-${path}`;
export const AuthTag = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Badge, {
    use: "koala",
    paddingInlineEnd: "200",
    children: /*#__PURE__*/_jsx(Text, {
      textTransform: "none",
      typography: "heading-25",
      children: children
    })
  });
};

/**
 * Renders the scopes as tags
 */
export const renderAuthTypes = securityTypes => {
  if (!securityTypes.length) {
    return /*#__PURE__*/_jsx(AuthTag, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.authTypes.NO_AUTH"
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: securityTypes.map(securityType => /*#__PURE__*/_jsx(AuthTag, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `developer-docs-shared-components.authTypes.${securityType}`
      })
    }, securityType))
  });
};